import * as Fingerprint from '@fingerprint/agent';
import { IS_E2E, IS_TEST } from '@onefootprint/dev-tools';
import { postHostedOnboardingFp } from '@onefootprint/fetch-hosted';
import type { FingerprintVisitPath } from '@onefootprint/request-types';
import { getLogger } from './logger';

const { logWarn } = getLogger({ location: 'submit-fingerprint' });

export type FingerprintData = {
  visitorId: string;
  requestId: string;
};

const apiKey = process.env.NEXT_PUBLIC_FINGERPRINT_API_KEY;
const envPath = process.env.NEXT_PUBLIC_FINGERPRINT_PATH;
const isDisabled = IS_TEST || IS_E2E;

const fetchFingerprintData = async (apiKey: string): Promise<FingerprintData> => {
  const client = Fingerprint.start({ apiKey, endpoints: 'https://fp.risk.onefootprint.com' });
  const result = await client.get();
  return {
    visitorId: result.visitor_id ?? '',
    requestId: result.event_id,
  };
};

const loadAndSubmit = async (options: { authToken: string; path: FingerprintVisitPath; documentId?: string }) => {
  try {
    if (!apiKey) {
      logWarn('No fingerprint API key');
      return;
    }
    const data = await fetchFingerprintData(apiKey);
    await postHostedOnboardingFp({
      body: {
        visitorId: data.visitorId,
        requestId: data.requestId,
        path: options.path,
        documentId: options.documentId,
      },
      headers: {
        'X-Fp-Authorization': options.authToken,
      },
    });
  } catch (error) {
    logWarn('Error fetching fingerprint data:', error);
  }
};

const getPath = (path: string | undefined): path is FingerprintVisitPath => {
  return path === 'onboard_start' || path === 'handoff' || path === 'identity_document_start';
};

const submitFingerprint = async (options: { authToken: string; path: FingerprintVisitPath; documentId?: string }) => {
  const path = options.path || envPath;
  const authToken = options.authToken;
  const documentId = options.documentId;

  if (isDisabled) {
    return;
  }
  if (authToken && getPath(path)) {
    loadAndSubmit({ path, authToken, documentId });
  }
};

export default submitFingerprint;
